<template>
    <div
        :class="`byos-choose-category-main-container filter-stage-content ${currentStage === 'category' ? 'd-block' : 'd-none'}`">
        <input type="hidden" class="isByosPage" value="true">
        <div class="byos-top-container pt-5 pb-4 r-container">
            <div class="byos-content-width px-3">
                <div class="row">
                    <div
                        :class="`col-12 col-md-7 selected-product-images-wrapper`">
                        <h2 class="choose-product-heading col-12 p-0" v-html="$t('chooseproducts.heading')"></h2>
                        <p class="choose-products-desc subheader2 col-12 px-0 mb-4 mb-md-5" v-html="$t('chooseproducts.description')">
                        </p>
                        <div class="justify-content-between d-flex">
                            <template v-for="product in boxProducts">
                                <div v-if="product" v-for="qtyIndex in product.qty" :key="product.id"
                                    class="image-container">
                                    <img :src="product.image" class="img-fluid byos-selected-img" :alt="product.name + ' ' + $t('product.addedtobox')"
                                        :data-product-id="product.id" />
                                </div>
                            </template>

                            <template v-for="index in (4 - totalAddedProducts)">
                                <div class="image-container">
                                    <img :src="jpgIcon('byos-placeholder' + (index + totalAddedProducts))"
                                        class="img-fluid byos-selected-img" alt="add product" :data-product-id="''" />
                                </div>
                            </template>

                        </div>
                        <a href="#" @click.prevent="scrollToTopProduct" v-if="boxProducts.length === 0"
                            :class="`btn btn-primary btn-block mt-4 ${totalAddedProducts > 0 ? 'd-none' : 'd-block d-sm-none'}`"
                            v-html="$t('byos.landing.addproducts')"></a>
                    </div>
                    <div :class="`col-12 col-md-5 mt-4 mt-md-0 ${totalAddedProducts > 0 ? '' : 'd-none d-sm-block'}`">
                        <div class="choose-products-container h-100">
                            <div class="selected-products-container h-100">
                                <div class="selected-products-content h-100 d-flex flex-column">
                                    <h2 class="box-contents-heading" v-html="$t('chooseproducts.boxcontents')"></h2>
                                    <div class="box-contents-container">
                                        <ByosChoosenProducts />
                                        <div class="bottom-border"></div>
                                    </div>
                                    <div class="selected-products-footer">
                                        <p class="sub-total-price text-right">
                                            <span v-html="$t('chooseproducts.subtotal')"></span>
                                            <span class="sub-total-value" :data-currency-format="pdict.currencyFormat"
                                                :data-currency-decimal-separator="pdict.currencyDecimalSeparator"
                                                v-html="subTotalValue">
                                            </span>
                                        </p>
                                    </div>
                                    <button class="btn btn-primary btn-block complete-box"
                                        data-component="byos/ByosButton"
                                        data-step="Step 2: Personalize"
                                        @click="onChooseCategoryStageFinish"
                                        :style="`opacity: ${totalAddedProducts > 0 ? '1' : '0.5'}`"
                                        v-html="$t('chooseproducts.completebox')" :disabled="totalAddedProducts === 0"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 stickyfooterpoint"></div>
            </div>
        </div>
        <!-- <isinclude template="BYOS/showBYOSProducts"/> -->
        <!-- <ByosShowProducts> -->
        <div v-if="pdict.renderedTemplate" v-html="pdict.renderedTemplate"></div>
        <!-- <ByosShowProducts /> -->

        <div class="mobile-selected-products-container">
            <div class="byos-content-width w-100 px-3">
                <div class="w-100 d-flex justify-content-between justify-content-md-end align-items-center">
                    <div class="mobile-images-container d-flex">
                        <template v-for="product in boxProducts">
                            <div v-if="product" v-for="qtyIndex in product.qty" class="mobile-img-container remove-product"
                                @click="() => { oldEventBus.$emit('removeProductFromBox', product.id)}" tabindex="0"
                                @keydown="(e) => { triggerRemove(e, product, oldEventBus, boxProducts) }"
                                :data-product-id="product ? product.id : ''" :aria-label="$t('label.product.remove', [product.name])" role="button">
                                <img :src="product.image" class="img-fluid mobile-byos-selected-img" :alt="product.name" />
                                <span class="ml-auto sticky-remove-product">
                                    <SvgHelper :icon="'close'" :svgtitle="'remove'" :decorative="true"></SvgHelper>
                                </span>
                            </div>
                        </template>

                        <template v-for="index in (4 - totalAddedProducts)">
                            <div class="mobile-img-container">
                                <SvgHelper :icon="'plus-bold'" :svgtitle="'add'" :decorative="true"></SvgHelper>
                            </div>
                        </template>
                    </div>
                    <button class="mobile-next-btn-container" :disabled="totalAddedProducts === 0"
                        :style="totalAddedProducts > 0 ? { 'pointer-events': 'auto', cursor: 'pointer', opacity: '1' } : { 'pointer-events': 'none', cursor: 'auto', opacity: '0.5' }"
                        @click="onChooseCategoryStageFinish">
                        <span
                            data-component="byos/ByosButton"
                            data-step="Step 2: Personalize"
                            :class="`complete-box-next-btn ${totalAddedProducts > 0 ? '' : 'disable-complete-box'} d-none d-sm-block`"
                            v-html="$t('chooseproducts.button.next')"></span>
                        <span class="icon-chevron">
                            <SvgHelper :icon="'chevron'" :svgtitle="'chevron'" :decorative="true"></SvgHelper>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- <isinclude template="BYOS/tagsAndRibbons"/> -->
    <ByosTagsAndRibbons />
    <!-- <isinclude template="BYOS/byosReview"/> -->
    <ByosReview />
</template>

<script setup>
import ByosTagsAndRibbons from '@/components/byos/ByosTagsAndRibbons.vue';
import ByosReview from '@/components/byos/ByosReview.vue';
import ByosChoosenProducts from '@/components/byos/ByosChoosenProducts.vue';

import { EventBus as oldEventBus } from "@/scripts/event-bus.js";
import { SvgHelper, jpgIcon } from "@/components/helper/util"
import { triggerRemove } from "@/components/helper/byos/byosHelper"
import { mapState, mapGetters, mapMutations, mapActions } from "@/store/helper/vuex";

const { pdict, currentStage, boxProducts, subTotalValue, totalAddedProducts } = mapGetters();
const { setByosSessionStorage } = mapMutations();
const { actionURLs } = mapState();
const { onSetCurrentStage, applyFilter } = mapActions();

const scrollToTopProduct = () => {
    $('html, body').animate({
        'scrollTop': $('.product-grid').offset().top - 110
    });
}

const onChooseCategoryStageFinish = () => {
    setByosSessionStorage();
    onSetCurrentStage('tagsAndRibbons');
}
</script>